const env = process.env;

export const SMART_CAPTCHA_KEY = env.REACT_APP_SMART_CAPTCHA_KEY;
export const SMART_CAPTCHA_TEST = !!env.REACT_APP_SMART_CAPTCHA_TEST;
